import { createFileRoute, redirect } from '@tanstack/react-router';
import { isOnboardingIsolated } from '@aegislab/shared';
import { McpTokensPage } from '@/pages/McpTokensPage';
import { useAuthStore } from '@/shared/model';

export const Route = createFileRoute('/settings/mcp-tokens')({
  beforeLoad: ({ location }) => {
    const user = useAuthStore.getState().user;
    if (!user) {
      // 목적지를 실어 보낸다 — 이 URL 을 팀에 공유하면 로그인 후 여기로 돌아와야 한다.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
    // 온보딩 격리 (CP1 D1): 윈도우 밖 별도 라우트도 격리 안이다 — 온보딩 흐름(홈)으로 돌려보낸다.
    // CP1 D3 가 이 화면의 상시 개방을 명시 기각했다 (격리 구멍만 늘림).
    if (isOnboardingIsolated(user)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/' });
    }
  },
  component: McpTokensPage,
});
